export const londonToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/London" });

export const chipTone = (due, owed) => {
  if (!due || !owed) return null;
  const days = Math.round((new Date(due) - new Date(londonToday())) / 86400000);
  if (days < 0) return { background: "#FDE7E7", color: "#B91C1C", borderColor: "#F0C5C5" };
  if (days <= 3) return { background: "#FFF3E0", color: "#B45309", borderColor: "#F3D9B1" };
  return null;
};
